(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-trust-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const phone = window.matchMedia('(max-width: 749px)');
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');

    const init = (grid) => {
      if (grid.dataset.pnTrustReady) return;
      grid.dataset.pnTrustReady = 'true';
      const items = Array.from(grid.children);
      const dots = Array.from(grid.parentElement.querySelectorAll('.pn-trust-bar__dot'));
      if (items.length < 2) return;
      let timer = null;
      let touched = false;

      const nearest = () => {
        const centre = grid.scrollLeft + grid.clientWidth / 2;
        let best = 0;
        let bestDistance = Infinity;
        items.forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft + item.offsetWidth / 2 - centre);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = index;
          }
        });
        return best;
      };

      const paint = () => {
        const index = nearest();
        dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
      };

      const go = (index) => {
        const item = items[index];
        grid.scrollTo({
          left: item.offsetLeft - (grid.clientWidth - item.offsetWidth) / 2,
          behavior: still.matches ? 'auto' : 'smooth',
        });
      };

      const stop = () => {
        touched = true;
        clearInterval(timer);
      };

      const start = () => {
        clearInterval(timer);
        if (!phone.matches || still.matches || touched) return;
        timer = setInterval(() => go((nearest() + 1) % items.length), 4000);
      };

      grid.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach((type) => grid.addEventListener(type, stop, { passive: true }));
      dots.forEach((dot, i) => dot.addEventListener('click', () => { stop(); go(i); }));
      phone.addEventListener('change', start);
      start();
      paint();
    };

    const run = () => document.querySelectorAll('[data-pn-trust-slider]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
